module.exports = __webpack_public_path__ + "media/Loops Perc.ad6a0fe8.wav";